export default "__VITE_ASSET__88a39d09__"